import { render, staticRenderFns } from "./ImageParser.vue?vue&type=template&id=636e180c"
import script from "./ImageParser.vue?vue&type=script&lang=js"
export * from "./ImageParser.vue?vue&type=script&lang=js"
import style0 from "./ImageParser.vue?vue&type=style&index=0&id=636e180c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports